/*
  This component is intended for extra-wide content children:
  • In TutorialGrid, it expands to fill both columns, and provides a shadow over the Table of Contents.
  • In ArticleGrid, it expands to match the width of the header.
*/
import { styled } from '@linaria/react';

import { HEADER_WIDTH } from '@/constants';

import ArticleGrid from './ArticleGrid';
import TutorialGrid, {
  TOC_WIDTH,
  TOC_THRESHOLD,
} from './TutorialGrid';

const FullWidthChild = styled.div`
  container-type: inline-size;

  ${TutorialGrid} & {
    @media (min-width: ${TOC_THRESHOLD + 0.01}rem) {
      position: relative;
      grid-column: 2 / 4;

      /*
        Add a fade effect to the Table of Contents so it appears to fade away as it approaches the Playground. This will hopefully make it clear that this isn’t a mistake. 😅
      */
      &::before {
        content: '';
        display: block;
        position: absolute;
        background: var(--color-background);
        width: ${TOC_WIDTH + 3}rem;
        height: 116%;
        top: -8%;
        right: 0;
        filter: blur(30px);
      }
    }

    @media (max-width: ${TOC_THRESHOLD}rem) {
      /* On smaller screens, tutorials behave like articles, so we’ll copy the styles applied to children in ArticleGrid: */
      grid-column: 1 / -1;
      padding-inline: var(--viewport-padding);
      margin-inline: auto;
      width: 100%;
      max-width: ${HEADER_WIDTH}rem;
    }
  }

  ${ArticleGrid} & {
    position: relative;
    grid-column: 1 / -1;
    padding-inline: var(--viewport-padding);
    margin-inline: auto;
    width: 100%;
    max-width: ${HEADER_WIDTH}rem;

    /* There’s no Table of Contents in the Article layout, but there is a floating sidebar with the "Like" button, and we want to cover that with the same blurry effect */
    @media (min-width: 61.625rem) {
      &::before {
        content: '';
        display: block;
        position: absolute;
        background: var(--color-background);
        width: 12rem;
        height: 116%;
        top: -8%;
        right: 0;
        filter: blur(30px);
      }
    }
  }
`;

export default FullWidthChild;
